module.exports = __webpack_public_path__ + "img/default-qualification-icon.238eef53.svg";